import { TextSelection } from '@atlaskit/editor-prosemirror/state';

import type { AISmartButtonOptions } from '../../types/types';

import { createCommand } from './plugin-factory';

export const removeSelectionCommand = ({
	aiSmartButtonOptions,
}: {
	aiSmartButtonOptions?: AISmartButtonOptions;
}) =>
	createCommand(
		(state) => true,
		(tr, state) => {
			aiSmartButtonOptions?.actions.removeContext();
			const { head } = state.selection;
			tr.setSelection(TextSelection.create(state.doc, head, head));
			return tr;
		},
	);
